export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4778.3b33e0ea.jpg";